// components/DistanceSalesModal.jsx
import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';

const DistanceSalesModal = ({ visible, onHide, onApprove }) => {
    const { t } = useTranslation();

    return (
        <Dialog
            visible={visible}
            onHide={onHide}
            header="Mesafeli Satış Sözleşmesi"
            style={{ width: '90vw', maxWidth: '800px', height: '80vh' }}
            className="distance-sales-modal"
            modal
            closable={true}
            resizable={false}
        >
            <div className="distance-sales-content" style={{ height: 'calc(80vh - 150px)', overflowY: 'auto', padding: '1rem 0' }}>
                <div className="prose prose-sm">
                    <h2 className="font-bold text-lg mb-4">MESAFELİ SATIŞ SÖZLEŞMESİ</h2>

                    <h3 className="font-bold text-md mb-3">1. TARAFLAR</h3>
                    <p className="mb-4">
                        Bu sözleşme aşağıdaki taraflar arasında aşağıda belirtilen hüküm ve şartlar çerçevesinde imzalanmıştır.
                    </p>

                    <div className="bg-gray-100 dark:bg-gray-700 p-4 rounded-lg mb-4">
                        <h4 className="font-bold mb-2">SATICI BİLGİLERİ:</h4>
                        <p><strong>Ünvan:</strong> Seyfullah Çalışkan</p>
                        <p><strong>Adres:</strong> Kdz. Ereğli / Zonguldak</p>
                        <p><strong>Telefon:</strong> +90 (532) 599 98 67</p>
                        <p><strong>E-posta:</strong> info@payplus.com.tr</p>
                        {/* <p><strong>KEP Adresi:</strong> payplus@hs01.kep.tr</p> */}
                        {/* <p><strong>Mersis No:</strong> [Mersis Numarası]</p> */}
                    </div>

                    <div className="bg-blue-50 dark:bg-blue-900 p-4 rounded-lg mb-4">
                        <h4 className="font-bold mb-2">ALICI BİLGİLERİ:</h4>
                        <p>Sözleşmeyi kabul eden kişi/kurum</p>
                    </div>

                    <h3 className="font-bold text-md mb-3">2. KONU</h3>
                    <p className="mb-4">
                        Bu sözleşmenin konusu, ALICI'nın SATICI'ya ait PayPlus platformu üzerinden elektronik ortamda
                        siparişini verdiği yazılım hizmet aboneliğinin satışı ve teslimi ile ilgili olarak 6502 sayılı
                        Tüketicinin Korunması Hakkında Kanun ve Mesafeli Sözleşmeler Yönetmeliği hükümleri gereğince
                        tarafların hak ve yükümlülüklerinin belirlenmesidir.
                    </p>

                    <h3 className="font-bold text-md mb-3">3. SÖZLEŞME KONUSU HİZMET BİLGİLERİ</h3>
                    <div className="bg-yellow-50 dark:bg-yellow-900 p-4 rounded-lg mb-4">
                        <h4 className="font-bold mb-2">HİZMET TANIMI:</h4>
                        <ul className="list-disc pl-5 space-y-1">
                            <li>PayPlus yazılım platformu abonelik hizmeti</li>
                            <li>Ödeme işlemleri yönetim sistemi</li>
                            <li>Müşteri destek hizmetleri</li>
                            <li>Teknik altyapı ve güvenlik hizmetleri</li>
                        </ul>
                    </div>

                    <h3 className="font-bold text-md mb-3">4. FİYAT VE ÖDEME BİLGİLERİ</h3>
                    <p className="mb-4">
                        Hizmet bedelinin tamamı sipariş esnasında önceden tahsil edilecektir. Fiyatlar KDV dahildir.
                        Seçilen abonelik süresine göre belirlenen toplam bedel, seçilen ödeme yöntemi ile tahsil edilir.
                    </p>
                    <ul className="list-disc pl-5 mb-4 space-y-1">
                        <li>Kredi kartı ile ödeme: Anlık tahsilat</li>
                        <li>Havale/EFT ile ödeme: Ödeme onayından sonra hizmet aktivasyonu</li>
                        <li>Fatura kesim tarihi: Ödeme tarihinden itibaren</li>
                    </ul>

                    <h3 className="font-bold text-md mb-3">5. TESLİMAT VE PERFORMANS</h3>
                    <p className="mb-4">
                        Hizmet dijital ortamda sunulacağı için fiziksel teslimat söz konusu değildir. Hizmet aktivasyonu
                        aşağıdaki şekilde gerçekleşir:
                    </p>
                    <ul className="list-disc pl-5 mb-4 space-y-1">
                        <li>Kredi kartı ödemesi: Anlık aktivasyon</li>
                        <li>Havale/EFT ödemesi: Ödeme onayından sonra 2 iş günü içinde</li>
                        <li>Kullanıcı hesap bilgileri e-posta yoluyla iletilir</li>
                        <li>7/24 teknik destek hizmeti başlar</li>
                    </ul>

                    <h3 className="font-bold text-md mb-3">6. CAYMA HAKKI</h3>
                    <p className="mb-4">
                        <strong>DİKKAT:</strong> 6502 sayılı Tüketicinin Korunması Hakkında Kanun'un 15. maddesi
                        gereğince aşağıdaki durumlar cayma hakkı kapsamı dışındadır:
                    </p>
                    <ul className="list-disc pl-5 mb-4 space-y-1">
                        <li>Tüketicinin isteği veya kişisel ihtiyaçları doğrultusunda hazırlanan mallara ilişkin sözleşmeler</li>
                        <li>Dijital içerik ve bilgisayar programlarına ilişkin sözleşmeler (İnternet ortamında anında ifa edilen hizmetler)</li>
                        <li>Cayma hakkı süresinde hizmetin ifasına başlanan abonelik sözleşmeleri</li>
                    </ul>

                    <div className="bg-red-50 dark:bg-red-900 p-4 rounded-lg mb-4">
                        <p className="text-red-800 dark:text-red-200 font-semibold">
                            PayPlus yazılım hizmeti, dijital içerik niteliğinde olup hizmetin ifasına derhal başlanacağından
                            cayma hakkı <strong>BULUNMAMAKTADIR</strong>.
                        </p>
                    </div>

                    <h3 className="font-bold text-md mb-3">7. ALICI'NIN YÜKÜMLÜLÜKLERİ</h3>
                    <ul className="list-disc pl-5 mb-4 space-y-1">
                        <li>Doğru ve eksiksiz bilgi sağlama</li>
                        <li>Ödeme yükümlülüğünü zamanında yerine getirme</li>
                        <li>Hizmet kullanım kurallarına uyma</li>
                        <li>Kullanıcı adı ve şifre güvenliğini sağlama</li>
                        <li>Yasalara aykırı işlem yapmama</li>
                        <li>Lisans koşullarına uygun kullanım</li>
                    </ul>

                    <h3 className="font-bold text-md mb-3">8. SATICI'NIN YÜKÜMLÜLÜKLERİ</h3>
                    <ul className="list-disc pl-5 mb-4 space-y-1">
                        <li>Hizmeti kesintisiz ve güvenli sunma</li>
                        <li>Teknik destek sağlama</li>
                        <li>Veri güvenliğini sağlama</li>
                        <li>Yasal mevzuata uygun hizmet sunma</li>
                        <li>Sistem güncellemelerini yapma</li>
                        <li>Müşteri şikayetlerini değerlendirme</li>
                    </ul>

                    <h3 className="font-bold text-md mb-3">9. FESIH VE İPTAL KOŞULLARI</h3>
                    <p className="mb-4">
                        Abonelik süresi sonunda otomatik olarak yenilenmez. Yenileme için ayrı sözleşme yapılması gerekir.
                        Aşağıdaki durumlarda sözleşme feshedilebilir:
                    </p>
                    <ul className="list-disc pl-5 mb-4 space-y-1">
                        <li>Taraflardan birinin sözleşme şartlarını ihlal etmesi</li>
                        <li>Ödeme yükümlülüklerinin yerine getirilmemesi</li>
                        <li>Yasalara aykırı kullanım tespit edilmesi</li>
                        <li>Teknik sebeplerle hizmet verilememe durumu</li>
                    </ul>

                    <h3 className="font-bold text-md mb-3">10. UYUŞMAZLIK ÇÖZÜMÜ</h3>
                    <p className="mb-4">
                        Bu sözleşmeden doğacak uyuşmazlıklarda aşağıdaki yollar izlenebilir:
                    </p>
                    <ul className="list-disc pl-5 mb-4 space-y-1">
                        <li>Öncelikle müşteri hizmetleri ile iletişim (info@payplus.com.tr)</li>
                        <li>Tüketici sorunları hakem heyetine başvuru</li>
                        <li>Zonguldak Mahkemeleri ve İcra Daireleri yetkilidir</li>
                        <li>Türk hukuku uygulanır</li>
                    </ul>

                    <h3 className="font-bold text-md mb-3">11. VERİ KORUMA VE GİZLİLİK</h3>
                    <p className="mb-4">
                        Kişisel verileriniz 6698 sayılı KVKK uyarınca korunur. Detaylı bilgi için KVKK Aydınlatma
                        Metnimizi inceleyiniz. Verileriniz sadece hizmet sunumu amacıyla kullanılır ve üçüncü
                        taraflarla paylaşılmaz.
                    </p>

                    <h3 className="font-bold text-md mb-3">12. YÜRÜRLÜLÜKDe</h3>
                    <p className="mb-4">
                        Bu sözleşme, ALICI tarafından onaylandığı tarihten itibaren yürürlüğe girer ve abonelik
                        süresi sonuna kadar geçerlidir. Sözleşme şartları değişiklikler önceden duyurularak
                        güncellenebilir.
                    </p>

                    <div className="bg-green-50 dark:bg-green-900 p-4 rounded-lg mt-6">
                        <p className="text-sm text-green-800 dark:text-green-200">
                            <strong>ONAY:</strong> Bu sözleşmeyi elektronik ortamda onaylayarak, tüm maddeleri
                            okuduğunuzu, anladığınızı ve kabul ettiğinizi beyan etmiş olursunuz. Sözleşme
                            11111 sayılı Kanun uyarınca elektronik imza ile imzalanmış sayılır.
                        </p>
                    </div>

                    <div className="bg-orange-50 p-4 rounded-lg mt-4">
                        <p className="text-sm text-orange-800">
                            <strong>Müşteri Hizmetleri:</strong><br />
                            Telefon: +90 (532) 599 98 67<br />
                            E-posta: info@payplus.com.tr<br />
                            Çalışma Saatleri: 7/24
                        </p>
                    </div>
                </div>
            </div>

            <div className="flex justify-end gap-3 mt-4 pt-4 border-t">
                <Button
                    label="İptal"
                    className="bg-gray-500 hover:bg-gray-600 text-white px-6 py-2 rounded-lg"
                    onClick={onHide}
                />
                <Button
                    label="Okudum ve Kabul Ediyorum"
                    className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-2 rounded-lg"
                    onClick={() => {
                        onApprove();
                        onHide();
                    }}
                />
            </div>
        </Dialog>
    );
};

export default DistanceSalesModal;